__turbopack_context__.v({
  "availabilityCalendarTitle": "cNsZnG_availabilityCalendarTitle",
  "availabilityCalendarWrapper": "cNsZnG_availabilityCalendarWrapper",
  "badges": "cNsZnG_badges",
  "basicProductDetailsWrapper": "cNsZnG_basicProductDetailsWrapper",
  "blurred": "cNsZnG_blurred",
  "blurredIconDescription": "cNsZnG_blurredIconDescription",
  "blurredIconWrapper": "cNsZnG_blurredIconWrapper",
  "buttonsFlexWrapper": "cNsZnG_buttonsFlexWrapper",
  "buttonsWrapper": "cNsZnG_buttonsWrapper",
  "detailsColumn": "cNsZnG_detailsColumn",
  "discountedDescriptionLabel": "cNsZnG_discountedDescriptionLabel",
  "favIconWrapper": "cNsZnG_favIconWrapper",
  "galleryWrapper": "cNsZnG_galleryWrapper",
  "maxPerSpecialOfferWrapper": "cNsZnG_maxPerSpecialOfferWrapper",
  "mobileContent": "cNsZnG_mobileContent",
  "productBrand": "cNsZnG_productBrand",
  "productCapacity": "cNsZnG_productCapacity",
  "productCardWrapper": "cNsZnG_productCardWrapper",
  "productDetailsContent": "cNsZnG_productDetailsContent",
  "productDetailsContentWrapper": "cNsZnG_productDetailsContentWrapper",
  "productLabelsWrapper": "cNsZnG_productLabelsWrapper",
  "productName": "cNsZnG_productName",
  "productSets": "cNsZnG_productSets",
  "sliderWrapper": "cNsZnG_sliderWrapper",
  "webContent": "cNsZnG_webContent",
});
